import { css } from 'styled-components';

export const SPINNER_ANIMATION_DURATION_IN_MS = 300;

export const spinnerTransitions = (classNamePrefix: string) => css`
  .${classNamePrefix}-enter {
    transform: scale(0.1);
  }

  .${classNamePrefix}-enter-active {
    transform: scale(1);
    transition: transform ${SPINNER_ANIMATION_DURATION_IN_MS}ms ease-in;
  }

  .${classNamePrefix}-exit {
    transform: scale(1);
  }

  .${classNamePrefix}-exit-active {
    transform: scale(0.1);
    transition: transform ${SPINNER_ANIMATION_DURATION_IN_MS}ms;
  }
`;
